import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    toggle() {
        const input = this.element.querySelector('input');
        const on = this.element.querySelector('.toggle-on');
        const off = this.element.querySelector('.toggle-off');

        this.element.classList.toggle('toggled');

        if (this.element.classList.contains('toggled')) {
            input.type = 'text';
            on.classList.remove('d-none');
            off.classList.add('d-none');
        } else {
            input.type = 'password';
            off.classList.remove('d-none');
            on.classList.add('d-none');
        }
    }
}
